export default "__VITE_ASSET__9XPjTlc4__"